import { ModuleCardView } from './ModuleCardView';
import type { IModuleSectionListProps } from './IModuleSectionListProps';

/**
 * Розділи плиток модулів (прототип v4, «Усі модулі» й навігатор Ctrl+K): підпис групи 11px великими літерами з кількістю IBM Plex Mono,
 * сітка плиток repeat(auto-fill, minmax(210px, 1fr)) з проміжком 8px.
 */
export function ModuleSectionList({ sections, onPin }: IModuleSectionListProps) {
  return (
    <>
      {sections.map((s) => (
        <section key={s.key} className="am-section" aria-label={s.label}>
          <div className="am-section__head"><span className="am-section__label">{s.label}</span><span className="am-section__count">{s.cards.length}</span></div>
          <div className="am-grid">{s.cards.map((c) => <ModuleCardView key={c.key} card={c} onPin={onPin} />)}</div>
        </section>
      ))}
    </>
  );
}
